import { i18n } from '../services/i18n.js';
import { icon } from '../services/icons.js';

const ZALO_GROUP_URL = 'https://zalo.me/g/3nmfszlfhv27f4yxas1t';

export const SupportView = container => {
  container.innerHTML = `
    <section class="support-page">
      <div class="container support-container">
        <div class="support-heading">
          <span>${i18n.t('support_eyebrow')}</span>
          <h1>${i18n.t('support_title')}</h1>
          <p>${i18n.t('support_intro')}</p>
        </div>

        <article class="support-card">
          <div class="support-icon">${icon('smile')}</div>
          <div class="support-card-copy">
            <span>${i18n.t('support_community')}</span>
            <h2>${i18n.t('support_zalo_title')}</h2>
            <p>${i18n.t('support_zalo_help')}</p>
          </div>
          <a class="btn btn-primary support-action" href="${ZALO_GROUP_URL}" target="_blank" rel="noopener noreferrer">
            ${i18n.t('support_join_zalo')} ${icon('arrowRight')}
          </a>
        </article>
      </div>
    </section>`;
};
